import { ICtaDestinationFields } from '@/types/contentful';
import { UrlByEnv } from '../context/PageData';
import { getRedirectByEnv } from './buildWebRegUrl';

function isProtocolUrl(url: string): boolean {
  return /^[a-z][a-z0-9+.-]*:/i.test(url);
}

function isAbsoluteUrl(url: string): boolean {
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return true;
  }

  if (
    url.startsWith('/') ||
    url.startsWith('#') ||
    url.startsWith('./') ||
    url.startsWith('../')
  ) {
    return false;
  }

  const domainPattern = /^([a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,}/i;
  return domainPattern.test(url) || url.startsWith('www.');
}

export function resolveCtaUrl(fields: Partial<ICtaDestinationFields> = {}) {
  const internalUrl = fields.internalLink?.trim();
  if (typeof internalUrl === 'string' && internalUrl.length > 0) {
    if (internalUrl.startsWith('/#')) return internalUrl.substring(1);
    if (internalUrl.startsWith('#')) return internalUrl;
    if (isProtocolUrl(internalUrl) || isAbsoluteUrl(internalUrl)) {
      return internalUrl;
    }
    return internalUrl.startsWith('/') ? internalUrl : `/${internalUrl}`;
  }
  const envUrl = getRedirectByEnv(fields as unknown as UrlByEnv);
  if (envUrl && (isProtocolUrl(envUrl) || isAbsoluteUrl(envUrl))) {
    return envUrl;
  }
  return envUrl;
}
